<div class="hamburger-menu-section">
  @if (tokenService.userInfo()) {
    <app-button Link="/watch-list" Icon="bookmarks" (Click)="close()" Appearance="default" Text="لیست من" />
  }
  <app-button
    [IsInSite]="false"
    Link="https://www.sheyda.com/download"
    Icon="download"
    (Click)="close()"
    Appearance="default"
    Text="دریافت اپلیکیشن‌های شیدا"
  />
  <app-button Link="/terms" Icon="article" (Click)="close()" Appearance="default" Text="قوانین و مقررات" />
  <app-button Link="/about-us" Icon="breaking_news_alt_1" (Click)="close()" Appearance="default" Text="درباره ما" />
  <mat-divider />
  <app-button
    Link="tel:90002908"
    [IsInSite]="false"
    Icon="call"
    [IsFillIcon]="true"
    Appearance="default"
    Text="تماس با ما"
  />
  <a class="social-button" href="https://www.instagram.com/sheyda.vod" target="_blank">
    <app-image-generator src="/images/icons/instagram.svg" name="instagram" imageType="square" />
    <span>صفحه‌ی اینستاگرام شیدا</span>
  </a>
</div>
